<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'default' | 'success' | 'error' | 'warning' | 'info'
  }>(),
  { variant: 'default' },
)

const variantClass: Record<string, string> = {
  default: 'bg-surface-container-highest text-primary-fixed-dim',
  success: 'bg-surface-container-highest text-status-on-scene',
  error: 'bg-error-container text-error',
  warning: 'bg-surface-container-highest text-status-rtb',
  info: 'bg-secondary-container text-secondary',
}
</script>

<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-0.5 font-mono text-[0.65rem] uppercase tracking-wide font-bold rounded',
      variantClass[variant],
    ]"
  >
    <slot />
  </span>
</template>
